module.exports = __webpack_public_path__ + "img/generate-content.6994b754.png";